<template>
    <div>
        <highcharts class="chart h-100 min-height-300" :constructor-type="'chart'" :options="chartOptions"></highcharts>
    </div>
</template>
<script>
export default {
    props: {
        chartData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            chartOptions: {
                ...{
                    chart: {
                        type: 'spline'
                    },
                    title: {
                        text: "Processing success",
                        align: "left",
                    },
                    yAxis: {
                        title: {
                            text: "Success processing(%)",
                        },
                        max: 100,
                    },
                },
                ...this.chartData
            }
        };
    },
};
</script>